var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._g(_vm._b({attrs:{"bottom":"","content-class":_vm.contentClass},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_vm._t("activator",null,null,{ on })]}}],null,true)},'v-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }